import { BoxGeometry, Mesh, MeshBasicMaterial, Quaternion, Vector3 } from 'three';
import { ActionControllerEventName, ResourcesManager, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import SkipTimeComponentModel from '../../components/SkipTimeComponentModel';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class IncubateModule extends ViewerModule {
    constructor(instruments, instrumentsPositions, table, pointerController, level) {
        super();
        this.__inited = false;
        this.dishPicked = false;
        this.dishReady = false;
        this.level = level;
        this.table = table;
        this.instruments = instruments;
        this.incubator = instruments.incubator;
        this.dish1 = instruments.dish1;
        this.instrumentsPositions = instrumentsPositions;
        this.pointerController = pointerController;
        this.incubatorPlantPosition = instrumentsPositions.incubator.clone();
        this.incubatorPlantPosition.sub(new Vector3(-0.16, -0.11, 0.8)); // FIXING PLANT POSITION
    }
    init() {
        let dishholderCallback;
        let callbackDish1;
        this.incubator = this.instruments.incubator;
        this.dish1 = this.instruments.dish1;
        this.dishOldPosition = this.instrumentsPositions.dish1.clone();
        // INIT DISH PICK
        this.dishHolder = new Mesh(new BoxGeometry(.25, 0.1, .25), new MeshBasicMaterial({ color: 0x00ff00 }));
        this.dishHolder.position.copy(this.dishOldPosition);
        this.dishHolder.position.y -= 0.01;
        this.dishHolder.visible = false;
        this.table.getObjectByName('ph_group').add(this.dishHolder);
        console.log('INCUBATOR inited');
        this.actionController.on(ActionControllerEventName.click, this.dish1, this.dishPickCallback = (event) => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (this.dishPicked)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.dishHolder.visible = true;
            this.dishPicked = true;
            this.visibilityShadow(this.dish1, false);
            this.pointerController.setObject(this.dish1);
        });
        this.actionController.on(ActionControllerEventName.click, this.dishHolder, dishholderCallback = (event) => {
            if (!this.level.interaction)
                return;
            if (!this.dishPicked)
                return;
            this.dish1.scale.set(1, 1, 1);
            this.visibilityShadow(this.dish1, true);
            this.pointerController.setObject(null);
            this.dishHolder.visible = false;
            this.dishPicked = false;
            this.dish1.position.copy(this.dishOldPosition);
            this.table.add(this.dish1);
            if (this.dishReady) {
                this.actionController.off(ActionControllerEventName.click, this.dishHolder, dishholderCallback);
                this.actionController.off(ActionControllerEventName.click, this.dish1, this.dishSecondPickCallback);
                this.fire('dish_ready');
            }
        });
        // CLEAN DISH PICK ENABLE
        this.actionController.on(ActionControllerEventName.click, this.incubator, callbackDish1 = () => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            if (this.dishPicked) {
                ResourcesManager.getAudioManger().getAudio('put_sound').play();
                this.visibilityShadow(Viewer.pointerController.currentPointerObject, true);
                this.pointerController.setObject(null);
                this.dishPicked = false;
                this.dishHolder.visible = false;
                this.dish1.scale.set(1, 1, 1);
                this.dish1.position.copy(this.incubatorPlantPosition);
                this.table.add(this.dish1);
                this.actionController.off(ActionControllerEventName.click, this.incubator, callbackDish1);
                this.actionController.off(ActionControllerEventName.click, this.dish1, this.dishPickCallback);
                this.fire('dish_planted');
            }
        });
        PreparationPickingObjects.saveObjectState(this.dish1);
        if (this.level.lobby.app.zSpacePickingController) {
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.dish1, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.dish1);
                // this.funnelModule.model.traverse(el => {
                //     el.userData.oldRaycast = el.raycast;
                //     el.raycast = () => {};
                // });
                // this.dishHolder.visible = true;
                this.dishPicked = true;
                this.visibilityShadow(this.dish1, false);
            });
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.dish1, () => {
                const distanceToIncubate = this.dish1.getWorldPosition(new Vector3()).distanceTo(new Vector3(-42.4, -17, 2.6));
                if (distanceToIncubate < 1.2) {
                    ResourcesManager.getAudioManger().getAudio('put_sound').play();
                    this.visibilityShadow(this.dish1, true);
                    this.dishPicked = false;
                    this.dishHolder.visible = false;
                    this.dish1.position.copy(this.incubatorPlantPosition);
                    this.dish1.rotation.set(0, 0, 0);
                    this.dish1.scale.set(1, 1, 1);
                    this.table.add(this.dish1);
                    this.actionController.off(ActionControllerEventName.click, this.incubator, callbackDish1);
                    this.actionController.off(ActionControllerEventName.click, this.dish1, this.dishPickCallback);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.dish1);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.dish1);
                    this.fire('dish_planted');
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(this.dish1);
                }
            });
        }
    }
    startTimer() {
        this.doorAnimation(this.incubator.getObjectByName('door'), true, () => {
            const sound = ResourcesManager.getAudioManger().getAudio('stopwatch_sound');
            sound.play();
            const soundInterval = setInterval(() => sound.play(), 300);
            let clocks = new SkipTimeComponentModel(1.5, { speedFactor: 350 });
            window['stc'] = clocks;
            clocks.uiObject.name = 'CLOCKS';
            clocks.start();
            clocks.uiObject.position.set(3.3, -1, -0.4);
            clocks.uiObject.rotation.set(0, -.44, 0);
            clocks.uiObject.userData.pcPosition = clocks.uiObject.position.clone();
            clocks.uiObject.userData.pcRotation = clocks.uiObject.rotation.clone();
            this.addObject(clocks);
            // if (Viewer.controls.zController) {
            //     clocks.uiObject.position.set(0, 0, 0);
            //     clocks.uiObject.rotation.set(0, 0, 0);
            //     clocks.uiObject.scale.setScalar(2.5 / this.level.lobby.app.determineZSpaceDevice.viewerScaleCoef);
            //     this.level.uiContainer.add(clocks.uiObject);
            // }
            setTimeout(() => {
                this.dishReady = true;
                this.fire('timer_end');
                sound.pause();
                clearInterval(soundInterval);
                clocks.stop();
                clocks.dispose();
            }, 13000);
        });
        // TIME`S UP! LET'S DOT THIS
    }
    openIncubator() {
        if (this.level.loopBurned) {
            this.dish1.add(ResourcesManager.getModel('petri_dish_green')); // GREEN DISH
        }
        else {
            this.dish1.add(ResourcesManager.getModel('petri_dish_red')); // RED DISH
        }
        this.dish1.getObjectByName('clear_dish').visible = false;
        this.doorAnimation(this.incubator.getObjectByName('door'), false, () => {
            this.actionController.on(ActionControllerEventName.click, this.dish1, this.dishSecondPickCallback = (event) => {
                if (Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (this.dishPicked && this.dishReady)
                    return;
                if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                    return;
                this.dishHolder.visible = true;
                this.dishPicked = true;
                this.visibilityShadow(this.dish1, false);
                this.pointerController.setObject(this.dish1);
            });
            if (this.level.lobby.app.zSpacePickingController) {
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.dish1, () => {
                    if (!this.level.interaction)
                        return;
                    Viewer.scene.add(this.dish1);
                    // this.funnelModule.model.traverse(el => {
                    //     el.userData.oldRaycast = el.raycast;
                    //     el.raycast = () => {};
                    // });
                    this.dishHolder.visible = true;
                    this.dishPicked = true;
                    this.visibilityShadow(this.dish1, false);
                });
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.dish1, () => {
                    if (!this.level.interaction)
                        return;
                    if (!this.dishPicked)
                        return;
                    this.dish1.rotation.set(0, 0, 0);
                    this.dish1.scale.set(1, 1, 1);
                    this.visibilityShadow(this.dish1, true);
                    this.dishHolder.visible = false;
                    this.dishPicked = false;
                    this.dish1.position.copy(this.dishOldPosition);
                    this.table.add(this.dish1);
                    const distanceToPH = this.dish1.getWorldPosition(new Vector3()).distanceTo(this.dishHolder.getWorldPosition(new Vector3()));
                    if (distanceToPH < 1) {
                        this.actionController.off(ActionControllerEventName.click, this.dishHolder);
                        this.actionController.off(ActionControllerEventName.click, this.dish1);
                        this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.dish1);
                        this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.dish1);
                        this.fire('dish_ready');
                    }
                });
            }
        });
    }
    doorAnimation(door, open, onComplete) {
        const oldRotation = new Quaternion().setFromEuler(door.rotation.clone());
        const newRotation = new Quaternion();
        const countRotation = () => {
            const a = door.rotation.clone();
            a.y = open ? 0 : Math.PI * 2 / 3;
            newRotation.setFromEuler(a);
        };
        countRotation();
        const tweenRotate = new Tween({ alpha: 0 }).to({ alpha: 1 }, 1000)
            .onUpdate((alpha) => {
            Quaternion.slerp(oldRotation, newRotation, door.quaternion, alpha);
        })
            .onComplete(onComplete ? onComplete : () => { })
            .start();
    }
    visibilityShadow(el, visibility = true) {
        const pPlane = el.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    update() {
    }
}
